import { useState, useEffect } from 'react'

export const useWellnessEducation = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [educationResources, setEducationResources] = useState([])

  useEffect(() => {
    fetchEducationResources()
  }, [])

  const fetchEducationResources = async () => {
    setIsLoading(true)

    try {
      // In production, this would be an API call to fetch educational resources
      // For now, we'll use mock data
      const options = [
        { value: 'nutrition-guide', label: 'Nutrition Guide' },
        { value: 'exercise-tutorial', label: 'Exercise Tutorial' },
        { value: 'stress-management-guide', label: 'Stress Management Guide' },
        { value: 'sleep-improvement-guide', label: 'Sleep Improvement Guide' },
        { value: 'mindfulness-introduction', label: 'Introduction to Mindfulness' },
        { value: 'meditation-guide', label: 'Meditation Guide' },
        { value: 'healthy-cooking', label: 'Healthy Cooking Guide' },
        { value: 'fitness-assessment', label: 'Fitness Assessment Guide' },
        { value: 'workout-plans', label: 'Workout Plans' },
        { value: 'mental-wellness-toolkit', label: 'Mental Wellness Toolkit' },
        { value: 'hydration-guide', label: 'Hydration Guide' },
        { value: 'ergonomics-guide', label: 'Ergonomics Guide' },
        { value: 'immune-support-guide', label: 'Immune Support Guide' },
        { value: 'work-life-balance', label: 'Work-Life Balance Guide' },
        { value: 'time-management', label: 'Time Management Guide' },
        { value: 'habit-formation', label: 'Habit Formation Guide' },
        { value: 'posture-improvement', label: 'Posture Improvement Guide' },
        { value: 'longevity-practices', label: 'Longevity Practices' },
        { value: 'digital-wellbeing', label: 'Digital Wellbeing Guide' },
        { value: 'nature-therapy', label: 'Nature Therapy Guide' },
        { value: 'breathing-techniques', label: 'Breathing Techniques' },
        { value: 'goal-setting', label: 'Goal Setting for Wellness' }
      ]

      setEducationResources(options)
    } catch (error) {
      console.error('Error fetching education resources', error)
    }

    setIsLoading(false)
  }

  const addCustomResource = (customOption) => {
    if (!customOption || !customOption.value || !customOption.label) return

    // Check if the option already exists
    const exists = educationResources.some((option) => option.value === customOption.value)
    if (exists) return

    setEducationResources([...educationResources, customOption])
  }

  const trackResourceEngagement = (resourceId, engagementData) => {
    // In production, this would make an API call to track resource engagement
    // Implementation would depend on your backend architecture
  }

  const assignResourceToPatient = (resourceId, patientId, assignmentData) => {
    // In production, this would make an API call to assign a resource to a patient

    // Implementation would depend on your backend architecture

    return {
      success: true,
      assignmentId: `assign_${Date.now()}`,
      message: 'Resource assigned successfully'
    }
  }

  const getResourceDetails = (resourceId) => {
    // In production, this would make an API call to get resource details

    // Mock return data
    return {
      id: resourceId,
      title: 'Comprehensive Wellness Guide',
      description: 'A complete guide to overall wellness practices and habits.',
      format: 'PDF',
      url: 'https://example.com/resources/wellness-guide.pdf',
      categories: ['general-wellness', 'healthy-habits'],
      recommendedFor: ['all-patients', 'wellness-plans'],
      engagementMetrics: {
        views: 245,
        completions: 187,
        averageRating: 4.7
      }
    }
  }

  return {
    isLoading,
    educationResources,
    fetchEducationResources,
    addCustomResource,
    trackResourceEngagement,
    assignResourceToPatient,
    getResourceDetails
  }
}
